export default __webpack_public_path__ + "static/media/H1005.bf523d6d.mp3";